<template>
  <v-row class="">
    <v-col
      cols="6"
      xl="3"
      md="4"
      :class="{ 'pt-1': true, 'pa-1': $vuetify.breakpoint.xsOnly }"
      v-for="pet in myPets"
      :key="pet._id"
    >
      <v-card
        outlined
        :height="$vuetify.breakpoint.smAndUp ? '253px' : '175px'"
        :min-width="$vuetify.breakpoint.smAndUp ? '250px' : '175px'"
        v-ripple
        @click="onSelect(pet._id, pet)"
        class="d-flex justify-center flex-column"
      >
        <div class="d-flex justify-center">
          <v-avatar
            :width="$vuetify.breakpoint.smAndUp ? 100 : 66"
            :height="$vuetify.breakpoint.smAndUp ? 100 : 66"
          >
            <v-img :src="pet.photo" />
            <v-icon
              :color="
                pet.gender === 'male'
                  ? $classStyle.genderMale
                  : $classStyle.genderFemale
              "
              :x-large="$vuetify.breakpoint.smAndUp"
              :style="{
                position: 'absolute',
                bottom: $vuetify.breakpoint.smAndUp ? '-34px' : '-24px',
                right: $vuetify.breakpoint.smAndUp ? '-34px' : '-24px',
                'z-index': 2
              }"
              v-text="
                pet.gender === 'male' ? 'mdi-gender-male' : 'mdi-gender-female'
              "
            ></v-icon>
          </v-avatar>
        </div>
        <div
          :class="{
            'text-center': true,
            'font-weight-bold': true,
            'mt-4': true,
            'body-2': $vuetify.breakpoint.xsOnly
          }"
          v-text="pet.name"
        ></div>
        <div
          :class="{
            'text-center': true,
            [$globalStyle.mainColor]: $vuetify.breakpoint.xsOnly,
            'body-2': $vuetify.breakpoint.xsOnly
          }"
        >
          {{ pet.breed }}
        </div>
        <div
          :class="{
            'text-center': true,
            'body-2': $vuetify.breakpoint.xsOnly
          }"
          v-text="$common.parsePetAge(pet.birth)"
        ></div>
      </v-card>
    </v-col>
    <v-col cols="6" xl="3" md="4" class="pt-1" v-if="showCreateNew">
      <v-card
        outlined
        height="253px"
        min-width="250px"
        v-ripple
        class="py-2 d-flex justify-center"
        @click="createNew"
      >
        <div class="d-flex flex-column align-self-center">
          <v-btn
            fab
            dark
            color="orange"
            depressed
            class="mb-2"
            :ripple="createBtnRipple"
          >
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
          <span class="orange--text mt-2">新增寵物</span>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: ["clinic", "showCreateNew", "phone", "filter"],
  data: () => ({
    createBtnRipple: false,
    myPets: [],
    pets: []
  }),
  watch: {
    phone() {
      this.getPets();
    },
    filter() {
      this.filterType();
    }
  },
  methods: {
    onSelect(petId, pet) {
      this.$emit("onSelect", petId, pet);
    },
    createNew() {
      this.$emit("createNew");
    },
    async getPets() {
      if (!this.phone) {
        return;
      }
      let response = await this.$ajax.get(
        `${this.$config.apiUrl}/${this.clinic}/pets/${this.phone}/0`
      );
      let thisVm = this;
      for (let pet of response.data) {
        pet.photo = await thisVm.loadPetAvatar(pet);
      }
      this.pets = response.data;
      this.filterType();
    },
    async loadPetAvatar(pet, forceReload) {
      let photoUrl = `${this.$config.apiUrl}/${this.clinic}/photo/avatar/${pet._id}`;
      if (forceReload) {
        photoUrl += "?t=" + new Date().getTime();
      }

      try {
        let response = await this.$ajax.get(photoUrl);

        if (JSON.stringify(response.data) === "{}") {
          return require(`../../assets/img_${pet.type || "other"}.png`);
        } else {
          return photoUrl;
        }
      } catch (e) {
        return require(`../../assets/img_${pet.type || "other"}.png`);
      }
    },
    async reloadPetAvatar(petId) {
      let thisVm = this;
      let targetPet;
      this.myPets.forEach(pet => {
        if (pet._id === petId) {
          targetPet = pet;
        }
      });
      if (targetPet) {
        console.log("reloadPetAvatar:" + petId);
        targetPet.photo = await thisVm.loadPetAvatar(targetPet, true);
      }
    },
    filterType() {
      if (!this.filter || this.filter === "all") {
        this.myPets = this.pets;
      } else {
        let thisVm = this;
        this.myPets = this.pets.filter(item => {
          return item.type === thisVm.filter;
        });
      }
    }
  },
  async mounted() {
    this.getPets();
  }
};
</script>
